import api, { USE_MOCK } from './apiClient';
import mockApi from '../mock/backend';

/**
 * Notifications: the ones you have received, and which ones you want.
 */
const EMPTY_PREFERENCES = {
  channels: ['app', 'email', 'whatsapp'],
  events: [],
  preferences: {},
  whatsappAvailable: false,
};

export const notificationService = {
  list() {
    if (USE_MOCK) return mockApi.listNotifications();
    return api.get('/notifications');
  },

  markRead(id) {
    if (USE_MOCK) return mockApi.markNotificationRead(id);
    return api.post(`/notifications/${id}/read`);
  },

  markAllRead() {
    if (USE_MOCK) return mockApi.markAllNotificationsRead();
    return api.post('/notifications/read-all');
  },

  /**
   * Which events reach you, on which channels.
   *
   * The catalogue of events comes from the server rather than being duplicated here, so the
   * Settings page cannot offer a toggle for something nothing sends.
   */
  preferences() {
    if (USE_MOCK) return Promise.resolve(EMPTY_PREFERENCES);
    return api.get('/notifications/preferences');
  },

  /** Partial: sending one event's one channel leaves everything else as it was. */
  savePreferences(patch) {
    if (USE_MOCK) return Promise.resolve(EMPTY_PREFERENCES);
    return api.patch('/notifications/preferences', patch);
  },
};

export default notificationService;
